import { IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import LoadingAnimation from "../../componets/loader/loader";
import { API } from "../../config/api";
import { DELETE, GET, POST } from "../../utils/apicalls";
import {
  Button,
  Card,
  Form,
  Input,
  Modal,
  notification,
  Space,
  Table,
} from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function OpeningHours() {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openinghours, setopeninghours] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const fetchOpeningHours = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.OPENING_HOURS_GET, {});
      setopeninghours(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchOpeningHours();
  }, []);

  // Handle form submission
  const submitHandler = async (values: any) => {
    try {
      let obj = {
        Time: values.Time,
        Day: values.Day,
      };

      setIsLoading(true);
      const postRequest: any = await POST(API.CREATE_OPENING_HOURS, obj);
      if (postRequest.status) {
        notification.success({ message: "opening hours added successfully!" });
        // Reset form and states
        form.resetFields();

        fetchOpeningHours(); // Fetch updated list
        setIsModalOpen(false); // Close modal
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id: any) => {
    try {
      setIsLoading(true);
      const delete_customer_url = `${API.DELETE_OPENING_HOURS}${id}`;
      const data: any = await DELETE(delete_customer_url);

      if (data.status) {
        notification.success({ message: "opening hour deleted successfully!" });
        fetchOpeningHours();
      } else {
        notification.error({
          message: "Something went wrong! Please try again later.",
        });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const confirmDelete = (id: any) => {
    const confirm = window.confirm("Are you sure you want to delete this ?");
    if (confirm) {
      handleDelete(id);
    }
  };

  const columns = [
    {
      title: "Index",
      dataIndex: "index",
      render: (_: any, __: any, index: number) => index + 1,
    },
    { title: "Day", dataIndex: "Day" },
    { title: "Time", dataIndex: "Time" },

    {
      title: "Actions",
      key: "actions",
      render: (_: any, record: any) => (
        <Space size="middle">
          <IconButton onClick={() => confirmDelete(record.id)} color="error">
            <DeleteIcon />
          </IconButton>
          <IconButton
            onClick={() =>
              navigate(
                `/Admin/adminOpeningHours/updateOpeningHours/${record.id}`
              )
            }
            color="primary"
          >
            <EditIcon />
          </IconButton>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div className="banner-container">
        {isLoading ? (
          <LoadingAnimation />
        ) : (
          <div className="banner-content">
            <h1 className="banner-title">Opening Hours</h1>
            <button
              className="banner-button"
              onClick={() => setIsModalOpen(true)}
            >
              Create Opening Hours
            </button>
          </div>
        )}
      </div>

      <div className="w-full px-4">
        <Card className="w-full">
          {isLoading ? (
            <LoadingAnimation />
          ) : (
            <div className="overflow-x-auto">
              <Table
                columns={columns}
                dataSource={openinghours}
                loading={isLoading}
                pagination={{ pageSize: 5 }}
                scroll={{ x: "max-content" }}
              />
            </div>
          )}
        </Card>
      </div>

      <Modal
        title="Add opening hours"
        visible={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width="90%"
      >
        <Form form={form} onFinish={submitHandler} layout="vertical">
          <Form.Item name="Day" label="Day" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="Time" label="Time" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Button type="primary" htmlType="submit" block>
            Submit
          </Button>
        </Form>
      </Modal>
    </div>
  );
}

export default OpeningHours;
